import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { FilterButton } from '@/components/ui/filter-button';
import Tabs from '@/components/ui/tabs';
import { MultiSelect } from '@/components/ui/multi-select';
import { useKnowledgeBaseFilters } from './hooks/useKnowledgeBaseFilters';

export default function KnowledgeBaseTypesFilter() {
  const {
    tabs,
    rootCategories,
    subcategoryOptions,
    handleSubcategoryChange,
    selectedSubcategoryIds,
    toggleSubcategory,
    visibleSubcategories,
    hasActiveFilters,
    hasSelectedCategories,
    resetFilters,
  } = useKnowledgeBaseFilters();

  return (
    <AnimatedFadeInComponent>
      <div className="mb-sh-60">
        <Tabs
          tabs={tabs}
          tabsClassesNames="!justify-start !gap-6"
          textClassNames="!text-sh-xs"
          selectClassNames="!mb-2"
          preserveCase={true}
        />

        {rootCategories.length > 0 && (
          <div className="flex flex-col gap-2 md:gap-3">
            <div className="flex flex-wrap items-center justify-center gap-2">
              <span className="hidden font-haffer text-sh-14-20 font-medium text-gray-700 md:inline">Categories</span>

              <div className="hidden flex-wrap items-center justify-center gap-2 md:flex">
                {hasSelectedCategories &&
                  visibleSubcategories.length > 0 &&
                  visibleSubcategories.map((subcategory) => (
                    <FilterButton
                      key={subcategory.documentId}
                      isSelected={selectedSubcategoryIds.includes(subcategory.documentId)}
                      hasBorder
                      showColorIndicator
                      onClick={() => toggleSubcategory(subcategory.documentId)}>
                      {subcategory.category}
                    </FilterButton>
                  ))}

                {hasActiveFilters && (
                  <button
                    type="button"
                    onClick={resetFilters}
                    className="font-haffer text-sh-14-20 font-bold text-black-100 hover:underline"
                    aria-label="Clear all filters">
                    Clear
                  </button>
                )}
              </div>

              <div className="flex w-full flex-col gap-2 md:hidden">
                {(hasSelectedCategories && subcategoryOptions.length > 0) || hasActiveFilters ? (
                  <div className="flex w-full min-w-0 items-center gap-2">
                    {hasSelectedCategories && subcategoryOptions.length > 0 ? (
                      <div className="min-w-0 flex-1">
                        <MultiSelect
                          options={subcategoryOptions}
                          value={selectedSubcategoryIds}
                          onValueChange={handleSubcategoryChange}
                          placeholder="Subcategories"
                          showSelectAll={false}
                        />
                      </div>
                    ) : null}
                    {hasActiveFilters && (
                      <button
                        type="button"
                        onClick={resetFilters}
                        className="shrink-0 font-haffer text-sh-14-20 font-bold text-black-100 hover:underline"
                        aria-label="Clear all filters">
                        Clear
                      </button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </AnimatedFadeInComponent>
  );
}
